import styled from 'styled-components';
import { INLINE_CONTROL_MIN_HEIGHT } from '../QuestionRow/QuestionRow.styled';

// The select is shorter than the line it shares with the question name, so the
// wrapper carries the line height and centres the select inside it. Without
// this the select sits at the top of the line and reads a few pixels high
// against the name, with or without an added price underneath.
export const InlineSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: ${INLINE_CONTROL_MIN_HEIGHT}rem;
`;
